const state = {
  states: [
    'initial',
    'importerSelected',
    'uploadStarted',
    'uploaded',
    'submitting',
    'submitted',
    'error',
    'lockForm',
  ],
  stateContainer: {
    initial: true,
  },
}

export { state }
